"use strict";

/* main.js
======================================= */
var APP = function () {
  /* init
  --------------------------------------------- */
  var _init = function _init() {
    $('#mobile-trigger').on('click', function () {
      $('#header').toggleClass('mobile-open');
    });
    $('.menu-ui .trigger').on('click', function () {
      $(this).parent().toggleClass('open');
    });
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.menu-ui').length) {
        $('.menu-ui.open').removeClass('open');
      }
    }); // Number Form

    $('.number-ui').each(function () {
      var $input = $(this).find('input');
      $(this).find('.btn-minus').on('click', function () {
        var value = parseInt($input.val()) - 1;
        if (value < 1) value = 1;
        var minVal = $input.attr('min') || 0;

        if (value < minVal) {
          return false;
        }

        $input.val(value).trigger('change');
        return false;
      });
      $(this).find('.btn-plus').on('click', function () {
        var value = parseInt($input.val()) + 1;
        var maxVal = $input.attr('max') || 100000;

        if (value > maxVal) {
          return false;
        }

        $input.val(value).trigger('change');
        return false;
      });
    }); // Menu UI

    $('.menu-ui').on('click', '.option', function () {
      var $trigger = $(this).closest('.menu-ui').find('.trigger');
      var $input = $(this).closest('.menu-ui').find('input');
      var value = $(this).data('value');
      $input.val(value).trigger('change', this).trigger('changex');
      ;
      $trigger.text($(this).text());
      $(this).closest('.menu-ui').removeClass('open');
    }) // Initialize display with whatever is already in the input value, since they're preserved between page refreshes.
    .filter('.menu-ui--dropdown').find('input').each(function () {
      var $menu = $(this).closest('.menu-ui');
      var value = this.value;
      $menu.data(value);
      var $matchingOption = $menu.find('.option').filter(function () {
        return $(this).data('value') == value;
      });

      if ($matchingOption.length) {
        $menu.find('.trigger').text($matchingOption.text());
      }
    });
  };
  /* _overlay_toggle
  --------------------------------------------- */


  var _overlay_toggle = function _overlay_toggle(element_id, event) {
    if (event) {
      if (!$(event.target).hasClass('overlay-scroll')) {
        return false;
      }
    }

    $(element_id).toggleClass('overlay-open');
    $('body').toggleClass('overlay-showing');
  };
  /* _faq_init
  --------------------------------------------- */


  var _faq_init = function _faq_init() {
    $('.faq-ui').on('click', '.entry', function () {
      $(this).toggleClass('open');
    });
  };
  /* _faq_page
  --------------------------------------------- */


  var _faq_page = function _faq_page(page) {
    $('.faq-sections .faq-ui.current').removeClass('current');
    $('.faq-sections .faq-ui').eq(page - 1).addClass('current');
    $('.faq-tabs .btn.current').removeClass('current');
    $('.faq-tabs .btn').eq(page - 1).addClass('current');
  };
  /* _switch_image
  --------------------------------------------- */


  var _switch_image = function _switch_image(that, image) {
    $(that).parent().find('.current').removeClass('current');
    $(that).addClass('current');
    $('#featured-image').attr('src', image);
  };
  /* _images_init
  --------------------------------------------- */


  var _images_init = function _images_init() {
    $('#thumbs-parent').on('click', '.thumb', function () {
      APP.overlay_toggle('#images-overlay');

      _load_image($(this));

      $('#thumbs-parent .current').removeClass('current');
      $(this).addClass('current');
    });
    $('#images-overlay').on('click', '.btn-prev', function () {
      var $current = $('#thumbs-parent .current');
      var $prev = $current.prev('.thumb');

      if ($prev.length == 0) {
        $prev = $('#thumbs-parent .thumb:last-child');
      }

      $current.removeClass('current');
      $prev.addClass('current');

      _load_image($prev);
    });
    $('#images-overlay').on('click', '.btn-next', function () {
      var $current = $('#thumbs-parent .current');
      var $next = $current.next('.thumb');

      if ($next.length == 0) {
        $next = $('#thumbs-parent .thumb:first-child');
      }

      $current.removeClass('current');
      $next.addClass('current');

      _load_image($next);
    });
  };

  var _load_image = function _load_image(target) {
    var spacer = $('#image_large-embed').data('spacer');
    var video_data = target.data('video');

    if (video_data) {
      var id = youtube_id(video_data);
      $('#image_large-embed').html("<div class=\"video-ui\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/".concat(id, "\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img src=\"").concat(spacer, "\" alt=\"\" />\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>"));
    }

    var image_data = target.data('image');

    if (image_data) {
      $('#image_large-embed').html("<img src=\"".concat(image_data, "\" alt=\"\" />"));
    }
  };
  /* youtube_id
  --------------------------------------------- */


  var youtube_id = function youtube_id(url) {
    var ID = '';
    url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

    if (url[2] !== undefined) {
      ID = url[2].split(/[^0-9a-z_\-]/i);
      ID = ID[0];
    } else {
      ID = url;
    }

    return ID;
  };
  /* _reset_contact
  --------------------------------------------- */


  var _reset_contact = function _reset_contact() {
    $('.contact-form input, .contact-form textarea').val('');
  };

  var initGuestCounter = function initGuestCounter(totalId, guestCounterId, pricePer) {
    var $total = $("#".concat(totalId));
    var $guestCounter = $("#".concat(guestCounterId));

    var fnSetPrice = function fnSetPrice() {
      var totalAmount = ($guestCounter.val() * pricePer / 100).toFixed(2);
      $total.text('$' + totalAmount);
    };

    $guestCounter.on('change', fnSetPrice);
    fnSetPrice();
  };
  /* public
  --------------------------------------------- */


  return {
    init: _init,
    faq_init: _faq_init,
    faq_page: _faq_page,
    overlay_toggle: _overlay_toggle,
    switch_image: _switch_image,
    images_init: _images_init,
    reset_contact: _reset_contact,
    initGuestCounter: initGuestCounter
  };
}();

window.APP = APP;

function htmlEscape(raw) {
  if (!raw) {
    return '';
  }

  return raw.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}